export const HAS_CUSTOM_LOGO = Boolean(process.env.REACT_APP_LOGO);
export const BRAND_LOGO = process.env.REACT_APP_LOGO || "/img/ong.jpg";
const DEFAULT_BRAND_NAMES = {
    fast: "빠른결제대행사",
    onu: "오앤유",
    baekma: "백마나무",
};
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME
    || DEFAULT_BRAND_NAMES[process.env.REACT_APP_HOST_BRAND]
    || DEFAULT_BRAND_NAMES.fast;
export const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || BRAND_NAME;

export default BRAND_LOGO;
